import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WildcardRoutingModule } from './wildcard-routing.module';

@NgModule({
  imports: [CommonModule, WildcardRoutingModule],
  declarations: [],
})
export class WildcardModule {}
